import { render, staticRenderFns } from "./Diagnostico.vue?vue&type=template&id=39e193af&"
import script from "./Diagnostico.vue?vue&type=script&lang=js&"
export * from "./Diagnostico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports